interface IArrowIcon {
    width: string,
    height: string,
    color: string,
}

const PreloaderIcon = (props: IArrowIcon) => {

    const { width, height, color } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={ width } height={ height }
             viewBox="0 0 24 24" strokeWidth="1.5" stroke={ color } fill="none" strokeLinecap="round"
             strokeLinejoin="round">
            <title>Loading...</title>
            <g>
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <line x1="12" y1="6" x2="12" y2="3"></line>
                <line x1="16.25" y1="7.75" x2="18.4" y2="5.6"></line>
                <line x1="18" y1="12" x2="21" y2="12"></line>
                <line x1="16.25" y1="16.25" x2="18.4" y2="18.4"></line>
                <line x1="12" y1="18" x2="12" y2="21"></line>
                <line x1="7.75" y1="16.25" x2="5.6" y2="18.4"></line>
                <line x1="6" y1="12" x2="3" y2="12"></line>
                <line x1="7.75" y1="7.75" x2="5.6" y2="5.6"></line>
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    from="0 12 12"
                    to="360 12 12"
                    dur="2s"
                    begin="0s"
                    repeatCount="indefinite"
                    fill="freeze"
                />
            </g>
        </svg>
    )
};

export default PreloaderIcon;